import { InfiniteData, useQueryClient } from '@tanstack/react-query';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import PageError from '../../components/Navigation/PageError/PageError';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import { ErrorBoundary } from '../../components/Shared/ErrorBoundary/ErrorBoundary';
import { useClientFields } from '../../sic-lib/api/hooks/useClientFields';
import { useContact } from '../../sic-lib/api/hooks/useContact';
import { InboxItemsResponse } from '../../sic-lib/api/newRecent/types/InboxItemsResponse';
import { useAppSelector } from '../../store/hooks';
import ContactLayout from './ContactLayout/ContactLayout';

export default function ContactDisplayPage() {
    const { contactId } = useParams<{ contactId: string }>();
    const queryClient = useQueryClient();

    const {
        data: contact,
        isLoading: isContactLoading,
        isError: isContactError,
    } = useContact(+contactId);
    const { data, isLoading: isFieldLoading, isError: isClientFieldsError } = useClientFields();

    const inboxFilterOptions = useAppSelector(state => state.inbox.filters.filter);

    React.useEffect(() => {
        if (contactId) {
            //clear unread count in new and recent list
            queryClient.setQueryData<InfiniteData<InboxItemsResponse> | undefined>(
                ['newAndRecent', inboxFilterOptions],
                oldData => {
                    oldData?.pages.forEach(page => {
                        page.items?.forEach(item => {
                            if (item.contactId === +contactId) {
                                item.unreadCount = 0;
                            }
                        });
                    });
                    return oldData;
                },
            );
        }
    }, [contactId]);

    return (
        <ErrorBoundary fallback={<PageError />}>
            <PageMain
                pageTitle="Contact"
                showError={isClientFieldsError || isContactError}
                showLoading={isFieldLoading || isContactLoading}
            >
                <>{!!contact && <ContactLayout contact={contact} />}</>
            </PageMain>
        </ErrorBoundary>
    );
}
